import React, { useState } from 'react';
import { Form, Container, Row, Col, Button, Modal } from 'react-bootstrap';
import { toast, ToastContainer } from "react-toastify";

import { useUser } from "../../UserContext";

import "react-toastify/dist/ReactToastify.css";
import "../../../css/DeleteData.css"


function DeleteData({ data, tableName, onDelete }) {

  const { role } = useUser(); 

  const [selectedID, setSelectedID] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  const ids = data.map(row => row.ID).filter(Boolean);

  const handleDeleteConfirmed = async () => {
    const formData = new URLSearchParams();
    formData.append("rowID", selectedID);
    formData.append("tableName", tableName);

    const API_URL = process.env.REACT_APP_API_URL;

    try {
      setIsLoading(true);
      const res = await fetch(`${API_URL}/deleteDB`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Delete failed");
      }

      await res.json();
      toast.success(`Riga con ID "${selectedID}" eliminata con successo`);

      // Reset selezione
      setSelectedID('');
      setShowModal(false);

      // Aggiorna parent table
      if (onDelete) onDelete();

    } catch (err) {
      console.error(err);
      toast.error(err.message || "Errore imprevisto");
      setShowModal(false);
    } finally {
      setIsLoading(false);
    }
  };

    // Se utente non loggato, mostra solo un messaggio
    if (!role) {
      return (
        <Container className="mt-5 text-center">
          <h5>Effettua il login per inserire nuovi dati.</h5>
        </Container>
      );
    }


  return (
    <Container className="mt-4">
      <ToastContainer position="top-right" autoClose={3000} />

      <Form className="delete-form p-4 rounded shadow-sm bg-light">
        <Row>
          <Col md={5}>
            <Form.Group>
              <Form.Label className="fw-semibold text-danger">
                Seleziona riga da eliminare (ID)
              </Form.Label>
              <Form.Select
                value={selectedID}
                onChange={(e) => setSelectedID(e.target.value)}
                required
                className="custom-select"
              >
                <option value="">-- Seleziona ID --</option>
                {ids.map((id) => (
                  <option key={id} value={id}>
                    {id}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mt-4 mb-2">
          <Col className="text-center">
            <Button
              variant="danger"
              size="lg"
              disabled={!selectedID || isLoading}
              onClick={() => setShowModal(true)}
              className="delete-btn"
            >
              {isLoading ? "Eliminazione..." : "CANCELLA RIGA"}
            </Button>
          </Col>
        </Row>
      </Form>


      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Conferma Eliminazione</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sei sicuro di voler eliminare la riga con <strong>ID "{selectedID}"</strong>? <br />
          <span className="text-danger fw-semibold">Questa azione è irreversibile.</span>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Annulla
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirmed}>
            Elimina
          </Button>
        </Modal.Footer>
      </Modal>

    </Container>
  );
}

export default DeleteData;
